import { render, staticRenderFns } from "./addSourceModal.vue?vue&type=template&id=1585b7ba&scoped=true"
import script from "./addSourceModal.vue?vue&type=script&lang=js"
export * from "./addSourceModal.vue?vue&type=script&lang=js"
import style0 from "./addSourceModal.vue?vue&type=style&index=0&id=1585b7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585b7ba",
  null
  
)

export default component.exports